// extracted by mini-css-extract-plugin
module.exports = {"infoPanelInner":"InfoPanel_infoPanelInner__3Ftai"};